import { render } from "./DTriStateCheckbox.vue?vue&type=template&id=53b8796c"
import script from "./DTriStateCheckbox.vue?vue&type=script&lang=js"
export * from "./DTriStateCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__